module.exports = __webpack_public_path__ + "img/p03.032b118e.jpg";